module.exports = __webpack_public_path__ + "static/media/history-disabled.a64018ed.svg";